import { render, staticRenderFns } from "./CopyAndResizeTemplateModal.vue?vue&type=template&id=53ffb90c"
import script from "./CopyAndResizeTemplateModal.vue?vue&type=script&lang=js"
export * from "./CopyAndResizeTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CopyAndResizeTemplateModal.vue?vue&type=style&index=0&id=53ffb90c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ffb90c')) {
      api.createRecord('53ffb90c', component.options)
    } else {
      api.reload('53ffb90c', component.options)
    }
    module.hot.accept("./CopyAndResizeTemplateModal.vue?vue&type=template&id=53ffb90c", function () {
      api.rerender('53ffb90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CopyAndResizeTemplateModal.vue"
export default component.exports